export { RoomRateConfigurationWizardVersion as RoomRateConfigurationWizard } from './RoomRateConfigurationWizardVersion';
